import React from 'react';
import { Info } from 'lucide-react';
import { formatNumber } from '../../../utils/analysis.utils';
import { useTranslation } from 'react-i18next';

interface DataCoverageInfoProps {
  prices: any;
  consumption: any;
}

export const DataCoverageInfo: React.FC<DataCoverageInfoProps> = ({
  prices,
  consumption
}) => {
  const { t } = useTranslation();

  if (!prices?.data || !consumption?.data) return null;

  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
      <div className="p-6">
        <div className="flex items-start gap-3">
          <Info className="w-5 h-5 text-brand-primary mt-0.5" />
          <div className="flex-1">
            <h3 className="font-medium text-gray-900 mb-3">{t('optimizationAnalysis.theoretical.dataCoverage.title')}</h3>
            <div className="grid md:grid-cols-2 gap-4 text-sm">
              <div>
                <p className="text-gray-600 font-medium">{t('optimizationAnalysis.theoretical.dataCoverage.pricePeriod')}</p>
                <p className="text-gray-900 mt-1">
                  {prices.data.length} {t('optimizationAnalysis.theoretical.dataCoverage.hours')} ({formatNumber(prices.data.length / 24, 0)} {t('optimizationAnalysis.theoretical.dataCoverage.days')})
                </p>
                {prices.data[0] && prices.data[prices.data.length - 1] && (
                  <p className="text-xs text-gray-500 mt-1">
                    {new Date(prices.data[0].timestamp).toLocaleDateString()} - {new Date(prices.data[prices.data.length - 1].timestamp).toLocaleDateString()}
                  </p>
                )}
              </div>
              <div>
                <p className="text-gray-600 font-medium">{t('optimizationAnalysis.theoretical.dataCoverage.consumptionPeriod')}</p>
                <p className="text-gray-900 mt-1">
                  {consumption.data.length} {t('optimizationAnalysis.theoretical.dataCoverage.hours')} ({formatNumber(consumption.data.length / 24, 0)} {t('optimizationAnalysis.theoretical.dataCoverage.days')})
                </p>
                {consumption.data[0] && consumption.data[consumption.data.length - 1] && (
                  <p className="text-xs text-gray-500 mt-1">
                    {new Date(consumption.data[0].timestamp).toLocaleDateString()} - {new Date(consumption.data[consumption.data.length - 1].timestamp).toLocaleDateString()}
                  </p>
                )}
              </div>
            </div>
            <div className="mt-4 p-3 bg-gray-50 rounded-lg">
              <p className="text-xs text-gray-600">
                <span className="font-medium">{t('optimizationAnalysis.theoretical.dataCoverage.noteLabel')}</span> {t('optimizationAnalysis.theoretical.dataCoverage.theoreticalNote', { hours: formatNumber(Math.min(prices.data.length, consumption.data.length), 0) })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};